// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 771) return "static/css/771.ca8176bba16f4e0007e6.lib.css";
	if (chunkId === 978) return "static/css/978.cc9b4a3e80e414fafe0c.css";
	// return url for filenames based on template
	return undefined;
};